import axios from "axios";

// export const baseUrl = "http://207.180.238.122:7082/";
export const baseUrl="/";

// export const baseUrl="https://ccpmrw.quizmasterr.com/";

export const loginApi = async (username, password) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, {
        username, password
    });
    return response;
}

export const misApi = async (startDate, endDate, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/new-mis`, {
        startDate, endDate
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const liveMisApi = async (tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/live-mis`, null, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const userLogsApi = async (msisdn, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/user-logs`, {
        msisdn
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const leaderboardApi = async (startDate, endDate, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/leaderboard`, {
        startDate, endDate
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });
    return response;
}

export const getBlacklistNumbersApi = async (tokenData) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/get-blacklisted-numbers`, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });

    return response;
}

export const blacklistMsisdnApi = async (msisdn, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/blacklist-msisdn`, {
        msisdn
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    });

    return response;
}

export const unsubMsisdnApi = async (msisdn, tokenData) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/unsub-msisdn`, {
        msisdn
    }, {
        headers: {
            Authorization: `Bearer ${tokenData?.token}`
        }
    })

    return response;
}